import React from 'react';
type Props = {
  className?: string;
  size?: number; // width in px
  rounded?: boolean;
};
/**
 * Simplified Union Jack SVG. 5:3 aspect ratio.
 * Sized small enough that the centred-saltire approximation reads correctly.
 */
export function UKFlag({
  className = '',
  size = 16,
  rounded = true
}: Props) {
  const w = size;
  const h = size * 0.6;
  return <span className={`inline-block overflow-hidden align-middle ${rounded ? 'rounded-[2px]' : ''} ${className}`} style={{
    width: w,
    height: h,
    lineHeight: 0
  }} aria-label="United Kingdom" role="img" data-id="element-751">
      <svg viewBox="0 0 60 36" width="100%" height="100%" preserveAspectRatio="none" data-id="element-752">
        {/* Background — Pantone 280 blue */}
        <rect width="60" height="36" fill="#012169" data-id="element-753" />
        {/* White saltires (diagonals) */}
        <path d="M0,0 L60,36 M60,0 L0,36" stroke="#FFFFFF" strokeWidth="8" shapeRendering="crispEdges" data-id="element-754" />
        {/* Red saltires */}
        <path d="M0,0 L60,36 M60,0 L0,36" stroke="#C8102E" strokeWidth="3" shapeRendering="crispEdges" data-id="element-755" />
        {/* White cross */}
        <path d="M30,0 V36 M0,18 H60" stroke="#FFFFFF" strokeWidth="10" data-id="element-756" />
        {/* Red cross */}
        <path d="M30,0 V36 M0,18 H60" stroke="#C8102E" strokeWidth="6" data-id="element-757" />
      </svg>
    </span>;
}